import { sendCtmEvtLog } from '@/utils/log'
export default {
    methods: {
        goIconLocation (e) {
            const { type, url, name } = e.currentTarget.dataset
            const location_list= {
                'comment': this.goComments,
                'consultant': this.goConsultant,
                'vr': this.goVR,
                'web720': this.openWeb720,
                'visit': () => this.goSubPagePath(this.visit_reservation_url),
                'planar': () => this.goSubPagePath(`/building/planar_graph?building_id=${this.house.id}`),
                'audios': () => this.goSubPagePath(`/pages/building/audio/main?building_id=${this.house.id}`),
                'sunlight': () => this.goSubPagePath(`/building/sunlight?building_id=${this.house.id}&title=${this.house.name}`),
            }
            sendCtmEvtLog(`楼盘详情top点击-${name}`)
            if (typeof(location_list[type]) === 'function') {
                location_list[type]()
            } else {
                wx.navigateTo({
                    url
                })
            }
        }
    }
}